import { Button } from "primereact/button";
import { FeedbackViewModel } from "../../../ViewModel/FeedbackViewModel";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useReducer } from "react";
import { Icons, LoadingBlock } from "../SharedComponents";
import { useNavigate } from "react-router";
import { Likert } from "./Likert";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { v4 as uuid } from 'uuid';
import { appInsights } from "../../../Services/AppInsightsService";

const feedbackRoute = '/journal/feedback';

export interface ITextInputVM {
    title: string;
    valueFN: () => string;
    onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
}


export function FeedbackButton({ viewModel }: { viewModel: FeedbackViewModel }) {

    const [shouldInitiallyShow] = React.useState(viewModel.ShowFeedbackButton);
    const [ShowFeedbackButton, setShowFeedbackButton] = React.useState(viewModel.ShowFeedbackButton);
    const [showDialogue, setShowDialogue] = React.useState(false);
    const navigate = useNavigate();



    useEffect(() => {
        appInsights.trackEvent({ name: 'FeedbackButtonRendered' });

        const updateShowFeedbackButton = () => {
            let temp = viewModel.ShowFeedbackButton;
            setShowFeedbackButton(temp);
        };
        viewModel.PropertyChanged.Subscribe(updateShowFeedbackButton);

        return () => {
            viewModel.PropertyChanged.Unsubscribe(updateShowFeedbackButton);
        }
    }, []);

    const animationName = ShowFeedbackButton ? 'fadeinright' : 'fadeoutright';

    return (
        shouldInitiallyShow &&
        <>
            <Button
                className={`gl-home-feedback-button gl-button-standard-typography ${animationName} animation-duration-1000 animation-ease-in-out animation-fill-forwards`}
                onClick={() => setShowDialogue(true)}
            >Feedback</Button>
            <Dialog
                className={`SettingsConfirmationPopup gl-popup w-full`}
                visible={showDialogue}
                dismissableMask
                resizable={false}
                maskClassName='gl-quote-mask'
                onHide={() => { if (!showDialogue) return; setShowDialogue(false); }}
                // breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                content={({ hide }) => (
                    <div className={`gl-settings-popup`}>
                        <button
                            className='gl-close-button'
                            onClick={(e) => {
                                hide(e);
                                setShowDialogue(false);
                            }}>
                            <Icons.CloseIcon />
                        </button>
                        <div className='gl-content-header-typography gl-header-content mt-125'>
                            <Icons.TitleIcon />
                            <p className="mt-0 mb-0">Have a minute to help the team?</p>
                        </div>
                        {/* <p className="gl-content-lowered-typography text-center pl-100 pr-100 mt-200 mb-0">Have a moment to help the Growth Lenses team?</p> */}
                        <p className="gl-content-lowered-typography text-center pl-100 pr-100 mt-200 mb-0">Please take a monent to tell us about your experiences with Growth Lenses so far.</p>
                        <div className="flex flex-row justify-content-around align-items-center">
                            <Button className={`gl-button-standard-typography gl-feedback-popup-action-button `}
                                onClick={() => { navigate(feedbackRoute); viewModel.FeedbackStarted(); }}
                            >Give Feedback</Button>
                        </div>
                        <div className="flex flex-row justify-content-around align-items-center mb-175">
                            <Button className={`gl-button-standard-typography gl-feedback-popup-remind-button `}
                                onClick={() => { setShowDialogue(false); viewModel.FeedbackStarted(); }}
                            >Remind Me Later</Button>
                        </div>
                    </div >
                )
                }
            />
        </>
    );
}

enum FeedbackPage {
    Page1,
    Page2,
    Page3,
    Page4
}

export function FeedbackEntryPage() {

    const [currentPage, setCurrentPage] = React.useState<FeedbackPage>(FeedbackPage.Page4);
    const [viewModel, setViewModel] = React.useState<FeedbackViewModel | null>(null);
    const [page4CaptureDetails, setPage4CaptureDetails] = React.useState<boolean>(false);
    const navigate = useNavigate();
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const buttonRef = React.useRef<HTMLDivElement>(null);


    useEffect(() => {

        const onPropertyChanged = () => {
            forceUpdate()
        };

        FeedbackViewModel.GetModel().then((vm) => {
            setViewModel(vm)
            vm.PropertyChanged.Subscribe(onPropertyChanged);
        });

        return () => {
            viewModel?.PropertyChanged.Unsubscribe(onPropertyChanged);
        };

    }, []);

    useEffect(() => {
        buttonRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    });


    if (!viewModel) {
        appInsights.trackEvent({ name: 'FeedbackViewModelNotReady', properties: { reason: 'viewModel undefined' } });
        return <LoadingBlock showLogo />;
    }
    switch (currentPage) {



        case FeedbackPage.Page1:
            return (
                <div className="h-full pt-200 flex flex-column justify-content-between">
                    <div className="pt-100 pl-100 pr-100" >
                        <div>
                            <h1 className="gl-app-title-typography text-left">Feedback</h1>
                            <p className="gl-content-lowered-typography text-left">Thank you for offering your feedback on Growth Lenses. Understanding your experiences and opinions helps make it better for you and other users.</p>
                        </div>
                        <div>
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page1VMs.csat}
                            />
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page1VMs.nps}
                            />
                        </div>
                    </div>

                    <div>
                        <Button
                            className="gl-button-standard-typography gl-feedback-button"
                            onClick={() => setCurrentPage(FeedbackPage.Page2)}
                            disabled={viewModel.Page1VMs.nps.scoreFN() === undefined}
                        >Continue</Button>
                    </div>
                </div>
            );


        case FeedbackPage.Page2:
            return (
                <div className="h-full pt-200 flex flex-column justify-content-between">
                    <div className="pt-100 pl-100 pr-100" >
                        <h1 className="gl-app-title-typography text-left">Feedback</h1>
                        <p className="gl-content-lowered-typography text-left">Thank you for offering your feedback on Growth Lenses. Understanding your experiences and opinions helps make it better for you and other users.</p>
                        <div>

                            <div className="gl-feedback-open-question  mt-150">
                                <h2 className="gl-today-info-typography text-left pl-100 pr-100">{viewModel.Page2VMs.constructiveFeedback.title}</h2>
                                <InputTextarea
                                    className="gl-feedback-textarea"
                                    value={viewModel.Page2VMs.constructiveFeedback.valueFN()}
                                    onChange={viewModel.Page2VMs.constructiveFeedback.onChange}
                                    autoResize
                                />
                            </div>


                            <div className="gl-feedback-open-question mt-150">
                                <h2 className="gl-today-info-typography text-left pl-100 pr-100 ">{viewModel.Page2VMs.positiveFeedback.title}</h2>
                                <InputTextarea
                                    className="gl-feedback-textarea"
                                    value={viewModel.Page2VMs.positiveFeedback.valueFN()}
                                    autoResize
                                    onChange={viewModel.Page2VMs.positiveFeedback.onChange}
                                />
                            </div>

                        </div>
                    </div>

                    <div>
                        <Button
                            className="gl-button-standard-typography gl-feedback-button"
                            onClick={() => setCurrentPage(FeedbackPage.Page3)}
                            disabled={
                                viewModel.Page2VMs.constructiveFeedback.valueFN().length === 0
                                || viewModel.Page2VMs.positiveFeedback.valueFN().length === 0
                            }
                        >Continue</Button>
                    </div>
                </div>
            );

        case FeedbackPage.Page3:
            return (
                <div className="h-full pt-200 flex flex-column justify-content-between">
                    <div className="pt-100 pl-100 pr-100" >
                        <h1 className="gl-app-title-typography text-left">Feedback</h1>
                        <p className="gl-content-lowered-typography text-left">Indicate your satisfaction with the GrowthLenses Journal in the following areas: </p>
                        <div>
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page3VMs.easeOfUse}
                            />
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page3VMs.technicalReliability}
                            />
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page3VMs.featuresCapabilities}
                            />
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page3VMs.visualAppeal}
                            />
                            <Likert
                                className="pl-100 pr-100"
                                {...viewModel.Page3VMs.speed}
                            />
                        </div>
                    </div>

                    <div ref={buttonRef}>
                        <Button
                            className="gl-button-standard-typography gl-feedback-button"
                            onClick={() => setCurrentPage(FeedbackPage.Page4)}
                        >Next</Button>
                    </div>
                </div>
            );


        //
        // Page 4 needs to be completely server driven so that we don't need to change the code
        // everytime we want to change the answers.
        //
        case FeedbackPage.Page4:

            const page4VMs = viewModel.Page4VMs;

            const SelectTasks = () => (
                <div>
                    <h3 className='gl-content-header-typography'>Select all that apply:</h3>
                    <div>
                        {
                            page4VMs.allTasks.map((task, index) => {

                                const checked = page4VMs.isChecked(index);
                                console.log('task', task, index, checked);
                                return (
                                    <div className="gl-feedback-task mt-100 flex flex-row justify-content-start align-items-center" key={task}>
                                        <Checkbox
                                            className="gl-feedback-checkbox justify-content-center align-items-center"
                                            inputId={`task${index}`}
                                            checked={checked}
                                            onClick={() => page4VMs.onSelectionChanged(index)}
                                        />
                                        <label htmlFor={`task${index}`}>{task}</label>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            );

            const DetailedFeedback = () => (
                <div>
                    {
                        page4VMs.taskVMs.map((taskVM) => {
                            return (
                                <div className="gl-feedback-task mt-100" key={uuid()}>
                                    <Likert
                                        {...taskVM}
                                    />
                                </div>
                            );
                        })
                    }
                </div>
            );


            return (
                <div className="h-full pt-200 flex flex-column justify-content-between">
                    <div className="pt-100 pl-100 pr-100" >
                        <h1 className="gl-app-title-typography text-left">Feedback</h1>
                        <p className="gl-content-lowered-typography text-left">In the last month, which of the following tasks have you tried to accomplish with GrowthLenses?</p>

                        {
                            !page4CaptureDetails
                                ?
                                <SelectTasks />
                                :
                                <DetailedFeedback />
                        }
                    </div>

                    <div>
                        <Button
                            className="gl-button-standard-typography gl-feedback-button"
                            onClick={() => {
                                if (!page4CaptureDetails) {
                                    setPage4CaptureDetails(true);
                                    return;
                                }
                                else {
                                    navigate('/journal/home');
                                }
                            }}
                            disabled={
                                (page4CaptureDetails && !page4VMs.showFinishButton())
                            }
                        >{page4CaptureDetails || !page4VMs.showNextButton() ? 'Finish' : 'Next'}</Button>
                    </div>
                </div >
            );

    }
}